<!-- 销售结算申请 -->
<template>
  <div class='page_content'>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch"></v-search>
      </div>

    </div>
    <div class="page_content_center">
        <div class="page_content_top_line page_content_top_line1">
          <el-tag size="medium" type="danger">￥{{ money }}</el-tag>
        </div>
      <el-table ref="table" size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" @selection-change="handleSelectionChange" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
        highlight-current-row>
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column v-if="tableValye.isShow == 1" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.entityField == 'psomState'">
              {{ $store.state.purchaseOrderState[scope.row[tableValye.entityField]].name }}
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomIswmsm'">
              {{ scope.row.psomIswmsm == 0 ? '否' : '是' }}
            </el-tag>
            <span v-else-if="tableValye.entityField == 'settleMode' || tableValye.entityField == 'dsapmState'">
              <span v-for="(item, i) in JSON.parse(tableValye.formatterContent)" :key="i">
                <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">{{
                                            item.value }}
                </el-tag>
              </span>
            </span>
            <span v-else-if="tableValye.fieldType == 'formatter'">
              <span v-for="(item, i) in JSON.parse(tableValye.formatterContent)" :key="i">
                <el-tag size="mini" v-if="item.value == scope.row[tableValye.entityField]">{{
                                            item.key }}
                </el-tag>
              </span>
            </span>
            <!-- <span v-else-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span> -->
            <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
            </span>
            <span v-else-if="tableValye.entityField == 'createTime'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <el-input @input="input(scope.$index, tableValye.entityField)" v-else-if="tableValye.entityField == 'settleMoney'" :ref="tableValye.entityField" v-model="scope.row[tableValye.entityField]" type="number"
              :min="0"></el-input>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <el-dialog title="记账" v-if="bookKeepShow" :visible.sync="bookKeepShow" width="60%">
      <div>
        <el-form @submit.native.prevent inline :model="sendDataInfo" ref="sendDataInfo" class="demo-form-inline" size="mini" :show-message="false">
          <el-form-item label="账簿编号" prop="abookCode" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
            <el-input clearable v-model="sendDataInfo.abookCode" @keyup.enter.native="openSearch('336844454858752', 0, 'abookCode', 'abookCode,abookId,abookName')">
              <el-button slot="append" @click="openSearch('336844454858752', 0, 'abookCode', 'abookCode,abookId,abookName')" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="账簿名称">
            <el-input clearable v-model="sendDataInfo.abookName" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际收款时间">
            <el-date-picker
              v-model="sendDataInfo.sjskTime"
              type="date"
              placeholder="选择实际收款时间">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div style="text-align: center;margin-top:20px;">
          <el-button type="primary" plain @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
    <el-dialog v-if="dialogExcel" title="导入EXCEL" :visible.sync="dialogExcel" width="60%">
      <import-file :uploadUrl="'suSettleAccount/upload0'" :importType="'suSettleAccountupload'" @closeExcel="closeExcel"></import-file>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        cmName: "",
        opmName: "",
        coName: "",
        payMethod: "",
        settleMethod: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000, //开始上一个月
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1, //当天最后时间
        cmId: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      money: 0,
      sublist: [],//选中的数据
      buttonList: [],
      pageShowData: [],//总数据（检索模版、表单模版、表格模版）
      formDataList: [],//表单数据模版
      addSalesForm: [],
      seId: "",
      seWidth: "",
      seTitle: "",
      DialogVisible: false,
      seType: "",
      smId: "",
      parentSearchData: {},
      requesUrl: '',
      imgUrl: '',
      ormId: '',
      bookKeepShow: false,
      sendDataInfo: {
        abookCode: "",
        abookId: "",
        abookName: "",
        sjskTime: new Date(),
        ids: []
      },
      type: "",
      sField: "",
      dialogExcel: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.smId = "";
        }
      },
      deep: true,
    },
    sublist: {
      handler: function (newValue, oldValue) {
        console.log(newValue);
        this.money = 0
        if (newValue.length > 0) {
          newValue.forEach(item => {
            this.money = this.$common.getDecimalInfo(3, item.settleMoney * 1 + this.money * 1)
          })
        } else {
          this.money = 0
        }
      },
      deep: true,
    },
    bookKeepShow() {
      if (!this.bookKeepShow) {
        this.init();
      }
    },
  },
  //方法集合
  methods: {
    input(index, entityField) {
      if (this.returnData.list[index].oldBalance < this.returnData.list[index].settleMoney) {
        this.returnData.list[index].settleMoney = this.returnData.list[index].oldBalance
      }else{
        this.$set(this.returnData.list[index], 'settleMoney', this.$common.updataNum('settleMoney', this.returnData.list[index]).settleMoney)
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          if (this.sublist.length == 0) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return
          }
          var flag = false
          var flag1 = false
          var arr = [];
          this.returnData.list.forEach((item, index) => {
            this.sublist.forEach(item1 => {
              if (item1.dasmId == item.dasmId) {
                if (item.settleMoney == 0 || item.settleMoney == "") {
                  flag = true
                  this.$refs["settleMoney"][index].$el.querySelector(".el-input__inner").style = `border:1px solid red !important;`
                }
                if (item.isCollection == 0) {
                  arr.push(item.orderId)
                  flag1 = true
                }
              }
            })
          })

          if (flag) {
            this.$message.error("结算金额不能为空或为零!");
            return
          } else if (flag1) {
            this.$message.error(`选中的还有未收款的订单!`);
            return
          }
          this.bookKeepShow = true
          break;
        case 1:
          this.handleExcel()
          break;
        case 2:
          window.location.href = this.requesUrl + `/suSettleAccount/importTemplate?ormId=${String(this.ormId)}`;
          break;
        case 9:  //导出
          this.exportData()
          break;
      }
    },
    // 导入EXCEL
    handleExcel() {
      this.dialogExcel = true

    },
    closeExcel(refresh) {
      this.dialogExcel = false
      if (refresh) this.getDataList()
    },
    exportData() {
      var start = this.getRequestData.start ? this.getRequestData.start : "";
      var end = this.getRequestData.end ? this.getRequestData.end : "";
      this.getRequestData.start = start
      this.getRequestData.end = end
      var params = Object.assign({}, this.getRequestData);
      params.ormId = this.ormId;
      console.log(params, this.requesUrl + '/suSettleAccount/exportSuElectronicOrderBy' + this.$common.getUrl(params),'111111');
      window.location.href = this.requesUrl + '/suSettleAccount/exportSuElectronicOrderBy' + this.$common.getUrl(params);
    },
    handleSelectionChange(val) {
      this.sublist = val
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      console.log(orderId);
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({
          //向窗口发送MessageEvent消息
          cmd: "returnFormJson",
          params: {
            isPenetrate
          }, //参数
        },
          "*"
        );
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.type = type
      this.sField = sField
      if (type == 'abookCode') {
        this.parentSearchData[type] = this.sendDataInfo[type]
      } else if (type == 'opmName') {
        this.parentSearchData[type] = this.getRequestData[type]
        this.parentSearchData.opmSalesperson = 1
      } else {
        this.parentSearchData[type] = this.getRequestData[type]
      }
    },
    changeInputModel(val) {
      console.log(val);
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.type == 'abookCode') {
          this.paramValue(val)
        } else {
          this.getRequestData[this.type] = val[this.type]
          this.paramValue1(val)
        }
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
    },
    // 赋值字段
    paramValue1(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
      console.log(arr, this.getRequestData);
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.subFn()
        } else {
          this.$message({
            message: '请完善必填项！',
            type: "error",
          });
          return false;
        }
      });
    },
    subFn() {
      this.$confirm("确定将选中记账吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.sub()
        })
        .catch(() => { });
    },
    async sub() {
      console.log(this.sendDataInfo);
      var arr = []
      this.sublist.forEach(item => {
        arr.push(
          {
            abookId: this.sendDataInfo.abookId,
            settleMoney: item.settleMoney,
            oldBalance: item.oldBalance,
            dasmId: item.dasmId,
            sjskTime: this.sendDataInfo.sjskTime.getTime()
          }
        )
      })
      let responseData = await this.$http.getOrderByOrdedrAccount(arr);
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$refs['sendDataInfo'].resetFields();
        this.bookKeepShow = false
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    //取消
    initActionBox(sendDataInfo) {
      this.$confirm("确定取消新增吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs[sendDataInfo].resetFields();
          this.bookKeepShow = false;
        })
        .catch(() => {
        });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == "ids") {
          this.sendDataInfo[key] = [];
        } else if (key == "sjskTime") {
          this.sendDataInfo[key] = new Date();
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },

    getSearchName(e) {
      this.seTitle = e;
    },
    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        this.pageShowData.jurTableVo.jurconfigtable.push({
          chineseField: "结算金额",
          entityField: "settleMoney",
          fieldSort: 1,
          fieldType: "input",
          fieldWeight: 100,
          formatterContent: null,
          isCustomize: null,
          isRift: 0,
          isShow: 1,
          riftField: null,
          showField: "结算金额",
        })
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList();
        this.getButtonList();
        this.formDataList = this.pageShowData.jurFormVoList
        if (this.pageShowData.jurFormVoList.length != 0) this.addSalesForm = this.pageShowData.jurFormVoList[0].jurconfigform
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    //自定义设计
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.cmName == "") this.getRequestData.cmId = "";
      let responseData = await this.$http.querySuElectronicOrderBy(
        this.getRequestData
      );
      if (responseData.status == 200) {
        var list = responseData.result.list;
        list.forEach(item => {
          item.settleMoney = item.oldBalance
        })
        this.returnData.list = list
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
      console.log(this.buttonList)
    },
//获取图片存取的根路径
    imgurl() {
      // console.log(this.$store.getters.getConfig);
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.ormId = sessionStorage.getItem('ormId')
    this.getPageInfo();
    this.imgurl()

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    document.onkeydown = function () {
      if (window.event.keyCode === 38 || window.event.keyCode === 40) {
        window.event.returnValue = false;
      }
    }
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.el-drawer {
  outline: none;
}

.page_content_top_line1 {
  display: flex;
  justify-content: flex-end;
  padding: 0;
  padding-right: 10px;
  padding-bottom: 5px;
  margin-top: 5px;
}

::v-deep .el-dialog__header {
  padding: 20px 20px 10px !important;
}

::v-deep .el-dialog__headerbtn {
  top: 20px !important;
  right: 20px !important;
}
</style>